import script from "./deliverOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./deliverOrder.vue?vue&type=script&lang=ts&setup=true"

import "./deliverOrder.vue?vue&type=style&index=0&id=72f3418e&lang=scss"

const __exports__ = script;

export default __exports__